import { useCallback } from 'react';

import qs from 'qs';

import { useUtilityContext } from '@change-corgi/core/react/utilityContext';

import { useQueryParamValue } from 'src/app/shared/hooks/location';
import { useCurrentUserId, useSessionUuid } from 'src/app/shared/hooks/session';
import type { ShareAction, ShareChannel } from 'src/app/shared/hooks/share';
import { useAvailableShareActions } from 'src/app/shared/hooks/share';

import type { Context, Petition } from '../../types';

type UseFlyerShareArgs = { petition: Petition; context: Context; content: string };
export function useFlyerShare({ petition, context, content }: UseFlyerShareArgs): ShareAction {
	const { resolveUrl } = useUtilityContext();
	const sourceLocation = useQueryParamValue('source_location');
	const sessionUuid = useSessionUuid();
	const currentUserId = useCurrentUserId();

	const getContent = (_channel: ShareChannel) => '';

	const getUrl = useCallback(
		(_channel: ShareChannel) => {
			const utmParams = qs.stringify(
				{
					utm_source: 'share_petition',
					utm_medium: 'qr_code_flyer',
					utm_campaign: 'starter_dashboard',
					utm_content: content,
					recruited_by_id: sessionUuid,
					recruiter: currentUserId,
				},
				{ encodeValuesOnly: true },
			);
			return resolveUrl(`/p/${petition.slug}?${utmParams}`);
		},
		[content, currentUserId, petition.slug, resolveUrl, sessionUuid],
	);

	const getTrackingData = useCallback(
		(_channel: ShareChannel) => ({
			view_context: 'starter_dashboard',
			own_petition: petition.user.id === currentUserId,
			context,
			content,
			petition_id: `petition_${petition.id}`,
			source_location: sourceLocation,
		}),
		[content, context, currentUserId, petition.id, petition.user.id, sourceLocation],
	);

	const trackingEventName = 'share_petition';
	const channels = ['flyer'] as const;

	const options = { trackingEventName, getUrl, getTrackingData, getContent };

	return useAvailableShareActions(channels, options)[0];
}
